module.exports = __webpack_public_path__ + "img/presentation_q1.bf18ca8.png";